module.exports = __webpack_public_path__ + "10cbf162898ad64d4dbdd832a9975e9f.svg";